import type { Ctx } from "../../types";
import { Action } from "gg-wf-scripts";
import { toast } from "../../toast";

function csvCell(val: unknown): string {
  if (val === null || val === undefined) return "";
  const s = String(val);
  if (/[",\r\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

function csvRow(cells: unknown[]): string {
  return cells.map(csvCell).join(",");
}

function downloadCsv(filename: string, content: string): void {
  const blob = new Blob(["﻿" + content], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export const export_jobs_approved_unpaid_csv: Action<Ctx> = async ({ sb }) => {
  const { data, error } = await sb
    .from("v_jobs_list")
    .select(
      "id, claimed_by, school_name, start_date, end_date, days, pay_rate, f_total_pay, job_status, review_status, pay_status"
    )
    .eq("review_status", "approved")
    .eq("pay_status", "unpaid")
    .order("start_date", { ascending: true });

  if (error) {
    toast({ variant: "error", text: "Export failed. Try again" });
    return { ok: false, error: error.message };
  }

  const rows = data ?? [];
  if (rows.length === 0) {
    toast({
      variant: "warning",
      text: "No approved & unpaid jobs to export.",
    });
    return { ok: true };
  }

  const origin = window.location.origin;
  const header = [
    "Substitute",
    "School",
    "Start Date",
    "End Date",
    "Days",
    "Pay Rate",
    "Total Pay",
    "Job Status",
    "Review Status",
    "Pay Status",
    "Job ID",
    "Link",
  ];

  const lines = [csvRow(header)];
  for (const r of rows) {
    lines.push(
      csvRow([
        r.claimed_by,
        r.school_name,
        r.start_date,
        r.end_date,
        r.days,
        r.pay_rate,
        r.f_total_pay,
        r.job_status,
        r.review_status,
        r.pay_status,
        r.id,
        `${origin}/app/admin/jobs?modal=view&id=${r.id}`,
      ])
    );
  }

  const today = new Date().toISOString().slice(0, 10);
  downloadCsv(`approved-unpaid-jobs-${today}.csv`, lines.join("\r\n"));
  toast({
    variant: "success",
    text: `Exported ${rows.length} job${rows.length === 1 ? "" : "s"}.`,
  });
  return { ok: true };
};
